exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-responsive{position:relative;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;max-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
